import { Configuration, LogLevel } from '@azure/msal-browser';

/**
 * MSAL Konfiguration für Microsoft 365 Authentifizierung
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

/**
 * Scopes für Login-Anfrage (acquireTokenSilent — ohne claims, damit MSAL-Cache greift)
 */
export const loginRequest = {
  scopes: ['User.Read', 'GroupMember.Read.All'],
};

/**
 * Scopes für Graph API Aufrufe
 */
export const graphScopes = {
  user: ['User.Read'],
  groups: ['GroupMember.Read.All'],
};

/**
 * Graph API Endpoints
 */
export const graphEndpoints = {
  me: 'https://graph.microsoft.com/v1.0/me',
  memberOf: 'https://graph.microsoft.com/v1.0/me/memberOf',
};
